<div class="allocation-group--container">
  @if (filteredAllocationGroups$ | async; as allocationGroups) {
    <div>
      <ng-select
        class="ng-select--custom searchable address--selector"
        [items]="allocationGroups"
        bindValue="allocation_group_id"
        placeholder="Select Allocation Group"
        [searchable]="true"
        [typeahead]="searchSubject"
        (change)="onSelect($event)"
        [clearable]="false"
        dropdownPosition="bottom"
        [(ngModel)]="selectedAllocationGroupId"
        notFoundText="No items found"
        typeToSearchText="No items found">
        <ng-template ng-label-tmp let-item="item">
          <span class="d-block font-weight-bold font-5">{{ item.allocation_group_label }}</span>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <span class="font-weight-bold font-6">
            {{ item.allocation_group_label }}
          </span>
        </ng-template>
      </ng-select>
    </div>
  } @else {
    <div class="content-loader small mt-3">
      <div class="inline-loader"></div>
    </div>
  }
</div>


